import React from 'react';

import {type ArtifactVersionsGridMetadata} from './artifactVersionsGridTypes';
import {ensureEditableArtifactVersionMetricPanel} from './artifactVersionsGridUtils';

type UpdateArtifactVersionsGridMetadata = (
  getNextMetadata: (
    metadata: ArtifactVersionsGridMetadata
  ) => ArtifactVersionsGridMetadata
) => void;

export function useEnsureEditableArtifactVersionMetricPanel({
  panelCount,
  readOnly,
  updateMetadata,
}: {
  panelCount: number;
  readOnly: boolean;
  updateMetadata: UpdateArtifactVersionsGridMetadata;
}) {
  React.useEffect(() => {
    if (readOnly || panelCount > 0) {
      return;
    }

    updateMetadata(ensureEditableArtifactVersionMetricPanel);
  }, [panelCount, readOnly, updateMetadata]);
}
